
<main id="chargingstationprofiles-table">
  <div class="card">
    <div class="card-header">
      <div class="row card-title">
        <div class="col-8 text-start">
          <h5>
            <span class="float-start" i18n="@@CustomerOverviewHeader"><app-svg source="icons/feather/box" height="18" class="me-2"></app-svg> Ladepunktprofile ({{ tableFunctions.total$ | async }})</span>
          </h5>
        </div>
        <div class="col-4 text-end">
          <button class="btn btn-yellow ms-1 me-1"
                  data-bs-placement="left" [routerLink]="['create']">
            <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
            <span class="d-none d-md-inline ps-2" i18n="@@AddChargingStationButton">Profil hinzufügen</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div *ngIf="tableReady" [class]="tableView">
        <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" class="table-layout"></app-table>
      </div>

      <div *ngIf="!tableReady" class="loading-spinner-container">
        <div class="spinner-border text-primary loading-spinner-md" role="status">
          <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
        </div>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <div class="d-flex">
        <div class="flex-fill d-none d-md-inline">
          <div class="d-flex">
            <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
            <div class="flex">
              <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                      class="form-control form-select custom-select" aria-label=""
                      (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="75">75</option>
                <option [ngValue]="150">150</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
          <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                          [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                          [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
          </ngb-pagination>
        </div>

        <div class="flex-fill justify-content-end d-none d-md-inline">
          <div class="d-flex float-end">
            <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
            <div class="flex">
              <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                      aria-label="">
                <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                        [ngValue]="i + 1">
                  {{ i + 1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  </main>
  <router-outlet></router-outlet>



